import { ToolbarPlugin, ToolbarSlot } from '@react-pdf-viewer/toolbar';

import { DownloadPdf } from '../DownloadPdf/DownloadPdf';

import { CenteredItemWrapper, ItemWrapper } from './PdfToolbar.styles';

type Props = {
  toolbarInstance: ToolbarPlugin;
  fileUrl: string;
  fileName?: string;
};

export const PdfToolbar: React.FC<Props> = ({ toolbarInstance, fileUrl, fileName }) => {
  const { Toolbar } = toolbarInstance;

  const toolbar = (slot: ToolbarSlot) => {
    const {
      ShowSearchPopover,
      ZoomOut,
      Zoom,
      ZoomIn,
      GoToNextPage,
      GoToPreviousPage,
      NumberOfPages,
      CurrentPageInput
    } = slot;
    return (
      <>
        <ItemWrapper>
          <ShowSearchPopover />
        </ItemWrapper>
        <ItemWrapper>
          <ZoomOut />
        </ItemWrapper>
        <ItemWrapper>
          <Zoom />
        </ItemWrapper>
        <ItemWrapper>
          <ZoomIn />
        </ItemWrapper>
        <CenteredItemWrapper>
          <GoToPreviousPage />
        </CenteredItemWrapper>
        <ItemWrapper>
          <CurrentPageInput /> / <NumberOfPages />
        </ItemWrapper>
        <ItemWrapper>
          <GoToNextPage />
        </ItemWrapper>
        <CenteredItemWrapper>
          <DownloadPdf fileUrl={fileUrl} fileName={fileName} />
        </CenteredItemWrapper>
      </>
    );
  };

  return <Toolbar>{toolbar}</Toolbar>;
};
